import axios from "axios";

export default {
  state: {
    activeUser: {},
    appsList: [],
  },
  getters: {
    getActiveUser(state) {
      return state.activeUser;
    },
    getTeam(state) {
      return state.team
    },
    getListApps(state){
      return state.appsList
    },
  },
  mutations: {
    activeUser(state, payload) {
      state.activeUser = payload;
    },
    clearUser(state, payload) {
      state.activeUser = payload;
    },
    setTeam(state, payload) {
      state.team = payload
    },
    setListApps(state, payload){
      state.appsList = payload
    },
  },
  actions: {
    setActiveUser(store, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/useractive",
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
        })
          .then(({ data, status }) => {
            if (status == 200) {
              store.commit("activeUser", data);
              return resolve(data);
            }
          })
          .catch((error) => {
            return reject(error);
          });
      });
    },
    changePass(store, payload) {
      return new Promise((resolve, reject) => {
        axios({
          method: "put",
          url: process.env.VUE_APP_BACKEND + "api/changepass",
          headers: {
            "Content-Type": "application/json",
            token: payload.token,
          },
          data: {
            old_pass: payload.old_pass,
            new_pass: payload.new_pass,
            confirm_pass: payload.confirm_pass,
            sso_pass: payload.sso_pass
          },
        })
          .then(({ data, status }) => {
            if (status == 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    changeProfile(store, payload) {
      return new Promise((resolve, reject) => {
        let form = new FormData();
        form.append("old_pass", payload.old_pass);
        form.append("new_pass", payload.new_pass);
        form.append("confirm_pass", payload.confirm_pass);
        form.append("signature", payload.signature);

        axios({
          method: "put",
          url: process.env.VUE_APP_BACKEND + "api/changesignature",
          headers: {
            "Content-Type": "multipart/form-data",
            token: payload.token,
          },
          data: form,
        })
          .then(({ data, status }) => {
            if (status == 200) {
              resolve(true);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchTeam(store, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/team",
          params: {
            tlc: payload
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token,
          },
        })
          .then(res => {
            store.commit("setTeam", res.data.data);
            resolve(res.data.data)
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    fetchAppsList(store, payload) {
      const storage = JSON.parse(localStorage.getItem("token"));
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/listApps",
          params: {
            tlc: payload
          },
          headers: {
            "Content-Type": "application/json",
            token: storage.token,
          },
        })
          .then(res => {
            store.commit("setListApps", res.data.data);
            resolve(res.data.data)
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async fetchSE(store, { lbl, token }) {
      return await new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: process.env.VUE_APP_BACKEND + "api/fetchSE",
          params: {
            lbl: lbl
          },
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    async saveNDAPandapakita(store, { tlc, password, file }) {
      return await new Promise((resolve, reject) => {
        const params = new FormData();
        params.append('tlc', tlc);
        params.append('password', password);
        params.append('signature', file);

        axios({
          method: "post",
          url: process.env.VUE_APP_BACKEND + "api/signinnda",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          data:params
        })
          .then(({ data, status }) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
